import { Group, Rect } from 'react-konva';
import { GraphStyle } from '../types';
import React from 'react';



const marginTop = -5
const marginBottom = -5

function GridBGCompact({
	columns = 20,
	rows = 5,
	style,
	...props
}: GridBGCompactProps) {



	// RENDER
	return (
		<Group
			{...props}
			listening={false}
		>

			{Array.from({ length: columns }).map((_, index) => index % 2 == 0 && (
				<Rect key={index}
					x={index * style.space.x}
					y={marginTop}
					width={style.space.x}
					height={(style.compact.y * rows)-marginBottom-marginTop}
					fill={style.bg.column0.color}
				/>
			))}

		</Group>
	);
}

export default GridBGCompact

type GridBGCompactProps = {
	columns: number,
	rows: number,
	style: GraphStyle,
}